<p [class.text-center]="centered" [class.mt-5]="centered">
  <button 
    pButton 
    type="button" 
    class="p-button-link" 
    wl-scroll-to-top 
    (click)="$event.preventDefault()" 
    icon="pi pi-arrow-circle-up" 
    [label]="'common.back-to-top' | translate">
  </button>
</p>